<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
      disable-resize-watcher
      floating
      class="hidden-lg-and-up"
      persistent
      
    >
      <v-list>
            <!--<template v-for="item in items">
            <v-list-tile :key="item.text" @click="">
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                <v-list-tile-title>
                    {{ item.text }}
                </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            </template>-->
            <template>
                <v-list-tile >
                    <v-list-tile-action>
                        <v-icon>account_circle</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ userName }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="logout">
                    <v-list-tile-action>
                        <v-icon>lock_open</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Odjava
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                
            </template>
        </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue darken-3"
      dark
      app
      fixed
      height="56px;"
    >
      <v-toolbar-title style="width: 300px;" :class="{ listMarginLeft: listMarginLeft }">
        <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-lg-and-up"></v-toolbar-side-icon>
        <span>Bohinj - zasedenost parkirišč</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y class="hidden-md-and-down">
        <v-btn slot="activator" color="" icon>
            <v-icon >menu</v-icon>
        </v-btn>
        <v-list class="hidden-md-and-down">
            <v-list-tile value="true">
                <!--<v-list-tile-avatar>
                <img src="http://svgur.com/i/65U.svg" alt="user">
                </v-list-tile-avatar>-->
                <v-list-tile-action>
                    <v-icon color="grey darken-3">account_circle</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                <v-list-tile-title><span class="grey--text text--darken-3">{{ userName }}</span></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile value="true" @click="logout">
                <v-list-tile-action>
                    <v-icon color="grey darken-3">lock_open</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                <v-list-tile-title><span class="grey--text text--darken-3">Odjava</span></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
        </v-menu>
    </v-toolbar>
    <v-content>
      <!--<v-container fluid fill-height>-->
        <v-layout justify-center align-center>
          <transition name="fade">
            <router-view/>
        </transition>

        <!--<my-loader></my-loader>-->
        </v-layout>
      <!--</v-container>-->
    </v-content>
    <!--<v-tooltip left>
        <v-btn
            fab
            bottom
            right
            color="red darken-1"
            dark
            fixed
            slot="activator"
            @click="refresh"
        >
            <v-icon>refresh</v-icon>
        </v-btn>
        <span>Osveži stanja</span>
    </v-tooltip>-->

    <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color=""
        >
        {{ text }}
            <v-btn
                color="pink"
                flat
                @click="snackbar = false"
            >
                Zapri
            </v-btn>
        </v-snackbar>
  </v-app>
</template>

<script>
import router from '.././router'
  export default {
    data: () => ({
      dialog: false,
      drawer: false,
      items: [
        { icon: 'account_circle', text: 'John Doe' },
        { icon: 'history', text: 'Odjava' },
      ],

      snackbar: false,
        y: 'bottom',
        x: 'left',
        mode: '',
        timeout: 3000,
        text: ''
    }),
    props: {
      source: String
    },

    computed: {
        listMarginLeft() {
            if(this.$vuetify.breakpoint.lgAndUp) {
                return true;
            }

            return false;
        },

        userName() {
            return this.$store.getters.user
        }
    },

    methods: {

        logout() {
            this.$store.dispatch('LOGOUT')
            .then(response => {
                router.push({
                name: 'login'
                })
            })
            .catch(error =>{
                window.console.log('Logout error')
                window.console.log(error)

            })
            .then(() => {

            })
        },

        refresh() {
            this.$store.dispatch('AVT_BLAGAJNA')
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
        }

    },

    created() {
        this.$store.dispatch('USER_DATA')
        this.$store.dispatch('AVT_BLAGAJNE')
        setInterval(() => {
            this.$store.dispatch('AVT_BLAGAJNE')
            .then(response => {
                //this.text = 'Posodabljane podatkov je uspelo.'
                //this.snackbar = true
                })
                .catch(error => {
                    console.log(error)
                })
            .catch(error => {   
                console.log(error)
                this.text = 'Pri osveževanju podatkov je prišlo do napake.'
                this.snackbar = true
            })
        }, 10000)
        
    }
  }
</script>

<style>
    html { overflow-y: auto !important; }
    .pointer {cursor: pointer;}
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .listMarginLeft {
        margin-left:-10px !important;
    }
</style>
